class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');

    if (!this.mainDetailsToggle) return;

    const summary = this.mainDetailsToggle.querySelector('summary');
    if (!summary) return;

    this.content = summary.nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.content) return;

    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle && this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    if (!this.mainDetailsToggle) return;

    this.mainDetailsToggle.removeAttribute('open');
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) {
      summary.setAttribute('aria-expanded', false);
    }
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverTimeout = null;

    // Add hover event listeners
    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));

    // Prevent default click behavior on summary
    const summary = this.querySelector('summary');
    const menuLink = this.querySelector('.header__menu-link');
    const menuToggle = this.querySelector('.header__menu-toggle');

    if (summary) {
      summary.addEventListener('click', this.onSummaryClick.bind(this));
    }

    // Handle menu link clicks separately
    if (menuLink) {
      menuLink.addEventListener('click', this.onMenuLinkClick.bind(this));
    }

    // Handle toggle clicks separately
    if (menuToggle) {
      menuToggle.addEventListener('click', this.onToggleClick.bind(this));
    }
  }

  onSummaryClick(event) {
    // Prevent the default details toggle behavior
    event.preventDefault();
  }

  onMenuLinkClick(event) {
    // Allow the link to navigate normally
    // Don't prevent default - let the link work
  }

  onToggleClick(event) {
    // Stop propagation to prevent triggering summary click
    event.stopPropagation();

    if (!this.mainDetailsToggle) return;

    // Toggle the menu
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.close();
    } else {
      this.mainDetailsToggle.setAttribute('open', '');
      const summary = this.mainDetailsToggle.querySelector('summary');
      if (summary) {
        summary.setAttribute('aria-expanded', true);
      }
      this.onToggle();
    }
  }

  onMouseEnter() {
    // Clear any existing timeout
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = null;
    }

    if (!this.mainDetailsToggle) return;

    // Open the menu
    this.mainDetailsToggle.setAttribute('open', '');
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) {
      summary.setAttribute('aria-expanded', true);
    }
    this.onToggle();
  }

  onMouseLeave() {
    // Add a small delay before closing to prevent accidental closes
    this.hoverTimeout = setTimeout(() => {
      this.close();
    }, 200);
  }

  onToggle() {
    if (!this.header) return;
    if (!this.mainDetailsToggle) return;

    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
